import { createContext } from 'react'

export const Palette = createContext([])
